module.exports = __webpack_public_path__ + "static/media/intel.b083033d.png";